import { HttpClient } from '@angular/common/http';
import { Data, Response, waitAndRetry } from '@dimandzhi/graphql';
import { currentMethodName } from 'app/current-method-name';
import { GraphQL } from 'app/graphql';
import { environment as env } from 'environments/environment';
import _ from 'lodash';
import { BehaviorSubject, Observable, OperatorFunction } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';

type gqlType = GraphQL.UserSchema.UserSelf;
const gqlType = GraphQL.UserSchema.UserSelf;
const ModelName = gqlType.getModelName();
export class UserSelf {
  private usersFirstCall: boolean;
  private users: BehaviorSubject<gqlType | undefined>;

  constructor(protected http: HttpClient) { }

  initUserSelf() {
    this.usersFirstCall = true;
    this.users = new BehaviorSubject<gqlType | undefined>(undefined);
  }

  getUserSelf(): Observable<gqlType>;
  getUserSelf(asSnapshot: boolean): gqlType | undefined;
  getUserSelf(
    asSnapshot?: boolean,
  ): Observable<gqlType> | (gqlType | undefined) {
    if (this.usersFirstCall) {
      this.refreshUserSelf();
      this.usersFirstCall = false;
    }
    if (asSnapshot) {
      return this.users.getValue();
    }
    return this.users
      .asObservable()
      .pipe(
        filter((userSelf) => userSelf !== undefined) as OperatorFunction<
          gqlType | undefined,
          gqlType
        >,
      );
  }

  updateUser(user: gqlType) {
    const action = 'update';
    const operationName = 'UpdateUser';
    return this.http.post<Response>(
      `${env.graphqlUser}/${currentMethodName()}`,
      JSON.stringify({
        query: `
          mutation ${operationName}($UserSettings: JsonObject) {
            ${ModelName} {
              ${action}(settings: $UserSettings)
            }
          }`,
        operationName: operationName,
        variables: {
          UserSettings: user.settings,
        },
      }),
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      },
    ).pipe(
      first(),
      Data.fromResp,
      map(data => {
        const result = _.get(data.get(), `${ModelName}.${action}`) as undefined | number;
        if (result === undefined) {
          throw new Error(`result is undefined`);
        }
        if (!_.isNumber(result)) {
          throw new Error(`result is not a number: ${typeof result} ${result}`);
        }
        return result;
      }),
    );
  }

  private refreshUserSelf() {
    this.http
      .post<Response>(
        `${env.graphqlUser}/${currentMethodName()}`,
        `query {
          ${ModelName} {
            self {
              ${gqlType.fields({ withSubFields: true })}
            }
          }
        }`,
      )
      .pipe(waitAndRetry, Data.fromResp)
      .subscribe({
        next: (data) => this.users.next(gqlType.getFromData(data)),
        error: (err) => this.users.error(err),
      });
  }
}
